import { render } from "./BanobagiHeader.vue?vue&type=template&id=23029907&scoped=true"
import script from "./BanobagiHeader.vue?vue&type=script&lang=js"
export * from "./BanobagiHeader.vue?vue&type=script&lang=js"

import "./BanobagiHeader.vue?vue&type=style&index=0&id=23029907&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23029907"]])

export default __exports__